<template>
  <div>
    <modal
      :width="width"
      @close="onCancel">
      <h3 slot="header">{{ challenge.name }} - {{ challenge.nameEng }}</h3>
      <div slot="body">
        <slot
          name="extra">
          <div>
            <accumulated-challenge-participants-table
              v-if="isAccumulatedType"
              :participants="participants"/>
            <streak-challenge-participants-table
              v-if="isStreakType"
              :participants="participants"/>
            <days-count-challenge-participants-table
              v-if="isDaysCountType"
              :participants="participants"/>
          </div>
        </slot>
      </div>
    </modal>
  </div>
</template>

<script>

import challengeApi from 'BRAND/api/challenge';
import Modal from '@/components/shared/dialogs/Modal';
import AccumulatedChallengeParticipantsTable from 'BRAND/components/challenge/participantsTables/AccumulatedChallengeParticipantsTable';
import StreakChallengeParticipantsTable from 'BRAND/components/challenge/participantsTables/StreakChallengeParticipantsTable';
import DaysCountChallengeParticipantsTable from 'BRAND/components/challenge/participantsTables/DaysCountChallengeParticipantsTable';

export default {
  components: {
    Modal,
    StreakChallengeParticipantsTable,
    AccumulatedChallengeParticipantsTable,
    DaysCountChallengeParticipantsTable
  },
  props: {
    challenge: {
      type: Object
    }
  },
  data () {
    return {
      width: '90rem',
      participants: []
    };
  },
  created () {
    document.body.addEventListener('keyup', this.onKeyUp);
    this.requestData();
  },
  destroyed () {
    document.body.removeEventListener('keyup', this.onKeyUp);
  },
  computed: {
    isAccumulatedType () {
      return this.challenge.type === 'accumulated';
    },
    isStreakType () {
      return this.challenge.type === 'streak';
    },
    isDaysCountType () {
      return this.challenge.type === 'days_count';
    }
  },
  methods: {
    onCancel (event) {
      this.$emit('close', event);
    },
    onKeyUp (event) {
      switch (event.keyCode) {
        case 27:
          this.$emit('close', event);
          break;
      }
    },
    requestData () {
      const challengeId = this.challenge.id;
      challengeApi.getChallengeParticipants(this, challengeId).then(data => {
        this.participants = data;
      }).catch(() => {
        // TODO (Display error)
      });
    }
  }
};

</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/brand/health/components/challenge/ChallengeParticipantsModal.vue